"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyDateRange = exports.parseDateRange = exports.groupOrdersByStatus = void 0;
const date_fns_1 = require("date-fns");
const groupOrdersByStatus = (array) => {
    return array.reduce((memo, order) => {
        if (!memo[order.orderStatus]) {
            memo[order.orderStatus] = [];
        }
        memo[order.orderStatus].push(order);
        return memo;
    }, {});
};
exports.groupOrdersByStatus = groupOrdersByStatus;
// @ts-ignore
const parseDateRange = (dateRange = "") => {
    const [start, end] = dateRange
        ? dateRange.split("/").map(date => new Date(date))
        : [(0, date_fns_1.startOfMonth)(new Date()), (0, date_fns_1.endOfMonth)(new Date())];
    return [(0, date_fns_1.startOfDay)(start), (0, date_fns_1.endOfDay)(end)];
};
exports.parseDateRange = parseDateRange;
// @ts-ignore
const stringifyDateRange = (dateRange = (0, exports.parseDateRange)()) => {
    return !dateRange.some((date) => date === null)
        ? dateRange.map((date) => date.toISOString()).join("/")
        : "";
};
exports.stringifyDateRange = stringifyDateRange;
//# sourceMappingURL=utils.js.map